<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = [
			{value:'adv_id',label:'Advertiser'},
			{value:'networkid',label:'Channel'},
			{value:'offerid',label:'Offer'},
			{value:'country',label:'Country'},
		]
		return{
			options,
		}
	},
	props:['value'],
}
</script>

